import Joi from 'joi';
import {
  PRIVACY_POLICY,
  REMEMBER_ME,
  TERMS_AND_CONDITIONS,
  URI_MAX_LENGTH
} from '../../constants/compliance-settings-enums';

const complianceSettings = Joi.object()
  .required()
  .keys({
    complianceResources: Joi.array()
      .required()
      .items(
        Joi.object()
          .keys({
            complianceType: Joi.string()
              .valid(PRIVACY_POLICY, REMEMBER_ME, TERMS_AND_CONDITIONS)
              .required(),
            uri: Joi.string()
              .max(URI_MAX_LENGTH)
              .required()
              .allow('')
          })
          .required()
      )
  });

export default complianceSettings;
